'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var socialMediaLinks = exports.socialMediaLinks = [{
    iconId: 'youtube-white',
    url: 'https://www.youtube.com/channel/UCGu3ZzSJU36GrjfpwGfpa_g'
}, {
    iconId: 'facebook-white',
    url: 'https://www.facebook.com/90Seconds.tv'
}, {
    iconId: 'twitter-white',
    url: 'https://twitter.com/90secondstv'
}, {
    iconId: 'linkedin-white',
    url: 'https://www.linkedin.com/company/90-seconds'
}];
var footerSections = exports.footerSections = [{
    columnTitle: 'About',
    items: [{ link: '/brand-terms', title: 'Brand terms & conditions' }, { link: '/creator-terms', title: 'Creator terms & conditions' }, {
        link: '/changes-refunds-policy',
        title: 'Changes and Refunds Policy'
    }, { link: '/privacy', title: 'Data protection policy' }, {
        link: '/acceptable-use-policy',
        title: 'Acceptable use policy'
    }, {
        link: 'https://support.90seconds.com/',
        title: 'Support',
        external: true
    }, { link: '/about', title: 'About 90' }, { link: '/about/team', title: 'Meet the team' }, { link: '/about/careers', title: 'Careers' }, { link: '/about/media', title: 'Media' }, { link: '/brands', title: 'Brands' }, { link: '/blog', title: '90 Blog' }]
}, {
    columnTitle: 'Region',
    items: [{
        link: 'https://90seconds.com.sg/',
        title: 'Asia',
        external: true
    }, {
        link: 'https://90seconds.com/',
        title: 'Europe',
        external: true
    }, {
        link: 'https://90seconds.com/',
        title: 'US',
        external: true
    }, {
        link: 'https://90seconds.com.au/',
        title: 'Australia',
        external: true
    }, {
        link: 'https://90seconds.jp/',
        title: 'Japan',
        external: true
    }, {
        link: 'https://90seconds.com/',
        title: 'New Zealand',
        external: true
    }]
}, {
    columnTitle: 'Features',
    items: [{
        link: '/features/end-to-end-workflow',
        title: 'End-to-end workflow',
        external: false
    }, {
        link: '/features/creative-briefing',
        title: 'Creative briefing'
    }, {
        link: '/features/built-in-publishing',
        title: 'Built-in publishing'
    }, {
        link: '/features/shoot-anywhere',
        title: 'Shoot anywhere'
    }, {
        link: '/features/accurate-scoping',
        title: 'Accurate scoping'
    }, {
        link: '/features/centralized-assets',
        title: 'Centralized assets'
    }, {
        link: '/features/real-time-collaboration',
        title: 'Real-time collaboration'
    }, {
        link: '/features/global-marketplace',
        title: 'Global marketplace'
    }]
}, {
    columnTitle: 'Looking for',
    items: [{
        link: '/international-video-production',
        title: 'International video production',
        external: false
    }, {
        link: '/urgent-video-production',
        title: 'Urgent video production',
        external: false
    }, {
        link: '/youtube-video-production',
        title: 'Youtube video production',
        external: false
    }, {
        link: '/global-video-production',
        title: 'Global video production',
        external: false
    }, {
        link: '/multi-location-video-production',
        title: 'Multi-location video production',
        external: false
    }, {
        link: '/video-production-platform',
        title: 'Video video production',
        external: false
    }, {
        link: '/corporate-video-production',
        title: 'Corporate video production',
        external: false
    }, {
        link: '/video-production-partner',
        title: 'Video production partner',
        external: false
    }]
}];
var customImageSizes = exports.customImageSizes = {
    mobile: {
        width: 17,
        height: 17
    },
    tablet: {
        width: 17,
        height: 17
    }
};
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/components/page-footer/config.js
// module id = 1928
// module chunks = 0